{
  "m": {
    "f": "icons-b6e636b2",
    "u": 1024,
    "z": 1024,
    "s": 59648,
    "l": "d",
    "w": true,
    "h": "b6e636b2f4ab8fce8e654c62c9d58fd8c9a191dd6500f0c488f8ae8a2835ba5c"
  },
  "i": {
    "activity": [1024, [[59648, "currentColor"]]],
    "archive-restore": [1024, [[59649, "currentColor"]]],
    "arrow-down--w2_5": [1024, [[59650, "currentColor"]]],
    "arrow-down-left": [1024, [[59651, "currentColor"]]],
    "arrow-down-to-line": [1024, [[59652, "currentColor"]]],
    "arrow-down-up": [1024, [[59653, "currentColor"]]],
    "arrow-down": [1024, [[59654, "currentColor"]]],
    "arrow-left-right": [1024, [[59655, "currentColor"]]],
    "arrow-left": [1024, [[59656, "currentColor"]]],
    "arrow-up--w2_5": [1024, [[59657, "currentColor"]]],
    "arrow-up-down": [1024, [[59658, "currentColor"]]],
    "arrow-up-right": [1024, [[59659, "currentColor"]]],
    "arrow-up": [1024, [[59660, "currentColor"]]],
    "award": [1024, [[59661, "currentColor"]]],
    "badge-check": [1024, [[59662, "currentColor"]]],
    "banknote": [1024, [[59663, "currentColor"]]],
    "barcode": [1024, [[59664, "currentColor"]]],
    "bluetooth-off": [1024, [[59665, "currentColor"]]],
    "bluetooth": [1024, [[59666, "currentColor"]]],
    "book-open": [1024, [[59667, "currentColor"]]],
    "building-2": [1024, [[59668, "currentColor"]]],
    "calendar-days": [1024, [[59669, "currentColor"]]],
    "calendar-range": [1024, [[59670, "currentColor"]]],
    "camera": [1024, [[59671, "currentColor"]]],
    "chart-column": [1024, [[59672, "currentColor"]]],
    "chart-line": [1024, [[59673, "currentColor"]]],
    "check--w3": [1024, [[59674, "currentColor"]]],
    "check": [1024, [[59675, "currentColor"]]],
    "chevron-down": [1024, [[59676, "currentColor"]]],
    "chevron-left": [1024, [[59677, "currentColor"]]],
    "chevron-right": [1024, [[59678, "currentColor"]]],
    "chevron-up": [1024, [[59679, "currentColor"]]],
    "circle-alert": [1024, [[59680, "currentColor"]]],
    "circle-check": [1024, [[59681, "currentColor"]]],
    "circle-dollar-sign": [1024, [[59682, "currentColor"]]],
    "circle-question-mark": [1024, [[59683, "currentColor"]]],
    "circle-x": [1024, [[59684, "currentColor"]]],
    "clipboard-check": [1024, [[59685, "currentColor"]]],
    "clipboard-list": [1024, [[59686, "currentColor"]]],
    "clock-3": [1024, [[59687, "currentColor"]]],
    "clock": [1024, [[59688, "currentColor"]]],
    "copy": [1024, [[59689, "currentColor"]]],
    "credit-card": [1024, [[59690, "currentColor"]]],
    "download": [1024, [[59691, "currentColor"]]],
    "earth": [1024, [[59692, "currentColor"]]],
    "ellipsis": [1024, [[59693, "currentColor"]]],
    "external-link": [1024, [[59694, "currentColor"]]],
    "eye-off": [1024, [[59695, "currentColor"]]],
    "eye": [1024, [[59696, "currentColor"]]],
    "file-text": [1024, [[59697, "currentColor"]]],
    "file-up": [1024, [[59698, "currentColor"]]],
    "flame": [1024, [[59699, "currentColor"]]],
    "flashlight": [1024, [[59700, "currentColor"]]],
    "fold-vertical": [1024, [[59701, "currentColor"]]],
    "folder-input": [1024, [[59702, "currentColor"]]],
    "folder-up": [1024, [[59703, "currentColor"]]],
    "funnel": [1024, [[59704, "currentColor"]]],
    "gamepad-2": [1024, [[59705, "currentColor"]]],
    "gauge": [1024, [[59706, "currentColor"]]],
    "gem": [1024, [[59707, "currentColor"]]],
    "globe": [1024, [[59708, "currentColor"]]],
    "grip-vertical": [1024, [[59709, "currentColor"]]],
    "hand-coins": [1024, [[59710, "currentColor"]]],
    "heart-pulse": [1024, [[59711, "currentColor"]]],
    "heart": [1024, [[59712, "currentColor"]]],
    "image-off": [1024, [[59713, "currentColor"]]],
    "image-plus": [1024, [[59714, "currentColor"]]],
    "image": [1024, [[59715, "currentColor"]]],
    "info": [1024, [[59716, "currentColor"]]],
    "key-round": [1024, [[59717, "currentColor"]]],
    "keyboard": [1024, [[59718, "currentColor"]]],
    "layers": [1024, [[59719, "currentColor"]]],
    "layout-grid": [1024, [[59720, "currentColor"]]],
    "lightbulb": [1024, [[59721, "currentColor"]]],
    "link-2": [1024, [[59722, "currentColor"]]],
    "list-checks": [1024, [[59723, "currentColor"]]],
    "list-filter": [1024, [[59724, "currentColor"]]],
    "list": [1024, [[59725, "currentColor"]]],
    "lock-keyhole": [1024, [[59726, "currentColor"]]],
    "lock-open": [1024, [[59727, "currentColor"]]],
    "lock": [1024, [[59728, "currentColor"]]],
    "log-out": [1024, [[59729, "currentColor"]]],
    "mail": [1024, [[59730, "currentColor"]]],
    "map-pin": [1024, [[59731, "currentColor"]]],
    "map-pinned": [1024, [[59732, "currentColor"]]],
    "maximize-2": [1024, [[59733, "currentColor"]]],
    "maximize": [1024, [[59734, "currentColor"]]],
    "minimize": [1024, [[59735, "currentColor"]]],
    "minus--w3": [1024, [[59736, "currentColor"]]],
    "minus": [1024, [[59737, "currentColor"]]],
    "moon": [1024, [[59738, "currentColor"]]],
    "mouse-pointer-2": [1024, [[59739, "currentColor"]]],
    "move-right": [1024, [[59740, "currentColor"]]],
    "network": [1024, [[59741, "currentColor"]]],
    "package-plus": [1024, [[59742, "currentColor"]]],
    "package": [1024, [[59743, "currentColor"]]],
    "panel-left-close": [1024, [[59744, "currentColor"]]],
    "panel-left-open": [1024, [[59745, "currentColor"]]],
    "pen-line": [1024, [[59746, "currentColor"]]],
    "pen-tool": [1024, [[59747, "currentColor"]]],
    "pencil": [1024, [[59748, "currentColor"]]],
    "plus--w3": [1024, [[59749, "currentColor"]]],
    "plus": [1024, [[59750, "currentColor"]]],
    "printer": [1024, [[59751, "currentColor"]]],
    "qr-code": [1024, [[59752, "currentColor"]]],
    "receipt-text": [1024, [[59753, "currentColor"]]],
    "receipt": [1024, [[59754, "currentColor"]]],
    "redo-2": [1024, [[59755, "currentColor"]]],
    "refresh-cw": [1024, [[59756, "currentColor"]]],
    "repeat": [1024, [[59757, "currentColor"]]],
    "rocket": [1024, [[59758, "currentColor"]]],
    "rotate-ccw": [1024, [[59759, "currentColor"]]],
    "rows-3": [1024, [[59760, "currentColor"]]],
    "ruler": [1024, [[59761, "currentColor"]]],
    "scan-line": [1024, [[59762, "currentColor"]]],
    "scan-search": [1024, [[59763, "currentColor"]]],
    "scroll-text": [1024, [[59764, "currentColor"]]],
    "search": [1024, [[59765, "currentColor"]]],
    "settings": [1024, [[59766, "currentColor"]]],
    "share-2": [1024, [[59767, "currentColor"]]],
    "shield-check": [1024, [[59768, "currentColor"]]],
    "shopping-bag": [1024, [[59769, "currentColor"]]],
    "shopping-cart": [1024, [[59770, "currentColor"]]],
    "shuffle": [1024, [[59771, "currentColor"]]],
    "skip-forward": [1024, [[59772, "currentColor"]]],
    "sliders-horizontal": [1024, [[59773, "currentColor"]]],
    "sparkles": [1024, [[59774, "currentColor"]]],
    "split": [1024, [[59775, "currentColor"]]],
    "square-check-big": [1024, [[59776, "currentColor"]]],
    "square-dashed": [1024, [[59777, "currentColor"]]],
    "square": [1024, [[59778, "currentColor"]]],
    "star": [1024, [[59779, "currentColor"]]],
    "store": [1024, [[59780, "currentColor"]]],
    "sun": [1024, [[59781, "currentColor"]]],
    "tag": [1024, [[59782, "currentColor"]]],
    "tags": [1024, [[59783, "currentColor"]]],
    "ticket": [1024, [[59784, "currentColor"]]],
    "trash-2": [1024, [[59785, "currentColor"]]],
    "trending-up": [1024, [[59786, "currentColor"]]],
    "triangle-alert": [1024, [[59787, "currentColor"]]],
    "trophy": [1024, [[59788, "currentColor"]]],
    "undo-2": [1024, [[59789, "currentColor"]]],
    "user-round": [1024, [[59790, "currentColor"]]],
    "users": [1024, [[59791, "currentColor"]]],
    "wifi-off": [1024, [[59792, "currentColor"]]],
    "workflow": [1024, [[59793, "currentColor"]]],
    "x": [1024, [[59794, "currentColor"]]],
    "zoom-in": [1024, [[59795, "currentColor"]]],
    "zoom-out": [1024, [[59796, "currentColor"]]]
  }
}
